import { useQuery } from '@tanstack/react-query';
import { fetchSorEntityName, isSorId } from '@/lib/medcom/sorEntityName';

export function useSorEntityName(sorId: string | null): {
  name: string | null;
  isLoading: boolean;
} {
  const trimmed = sorId?.trim() ?? '';
  const enabled = isSorId(trimmed);
  const result = useQuery({
    queryKey: ['sor-entity-name', trimmed] as const,
    enabled,
    staleTime: 24 * 60 * 60 * 1000,
    queryFn: () => fetchSorEntityName(trimmed),
  });

  return {
    name: enabled ? (result.data ?? null) : null,
    isLoading: enabled && result.isLoading,
  };
}
